import type { ApprovalRequest } from '@/lib/types';
import { BucketShell } from './_BucketShell';
import { readStructuredFields } from './_payload';
import type { SupplierCandidate } from '../types';

export interface SupplierAmbiguousViewProps {
  req: ApprovalRequest;
}

function readSupplierCandidates(req: ApprovalRequest): SupplierCandidate[] {
  const sf = readStructuredFields(req);
  const candidates = sf['supplier_candidates'];
  return Array.isArray(candidates) ? (candidates as SupplierCandidate[]) : [];
}

export function SupplierAmbiguousView({ req }: SupplierAmbiguousViewProps) {
  const candidates = readSupplierCandidates(req);

  return (
    <BucketShell req={req}>
      <section className="rounded-lg border border-orange-300 bg-orange-50 p-16">
        <p className="text-xs font-semibold uppercase tracking-wide text-orange-800">
          Supplier ambiguous
        </p>
        <p className="mt-4 text-sm text-neutral-700">
          Multiple supplier records matched this NTN. Pick the correct one in the form below
          and save to revalidate.
        </p>
        {candidates.length > 0 ? (
          <p className="mt-12 text-sm text-neutral-600">
            {candidates.length} candidate{candidates.length === 1 ? '' : 's'} available.
            Pick the supplier below to revalidate.
          </p>
        ) : (
          <p className="mt-12 text-sm text-neutral-500">
            No candidates available. Use the form to enter a supplier code manually.
          </p>
        )}
      </section>
    </BucketShell>
  );
}
